import clsx from 'clsx'

interface PriceProps {
  price: string
  compareAtPrice?: string
  className?: string
  showSavings?: boolean // Optional prop to control showing savings
}

export function Price({ price, compareAtPrice, className, showSavings = true }: PriceProps) {
  const priceNum = parseFloat(price)
  const compareAtPriceNum = parseFloat(compareAtPrice || '0')
  const isOnSale = priceNum < compareAtPriceNum && compareAtPrice

  const formatPrice = (value: string) => {
    return value.replace(/\.(\d)0?$/, '.$10').replace(/\.00$/, '')
  }

  const calculatePercentageSaved = () => {
    if (!isOnSale) return 0
    const savings = compareAtPriceNum - priceNum
    return Math.round((savings / compareAtPriceNum) * 100)
  }

  const percentageSaved = calculatePercentageSaved()

  return (
    <p className={clsx(className)}>
      {isOnSale && (
        <span className="line-through paragraph-s mr-0.25">
          ${formatPrice(`${compareAtPrice}` || '')}
        </span>
      )}

      <span className={clsx('paragraph-s', isOnSale ? 'text-brand-sale' : '')}>
        ${formatPrice(`${price}`)}
      </span>

      {isOnSale && showSavings && percentageSaved > 0 && (
        <div className="flex items-center justify-start paragraph-s text-brand-sale">
          <p className='paragraph-s hidden lg:flex'><span className="px-0.25 lg:px-0.5`">|</span>You save {percentageSaved}%</p>
          <p className='paragraph-s flex lg:hidden'><span className="px-0.25 lg:px-0.5">|</span>Save {percentageSaved}%</p>
        </div>
      )}
    </p>
  )
}
